













































































































































































































































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import {
  EBatchStatus,
  EBatchType,
  EFacilityBlockableFeatures,
  EOrigin,
  EStatementStatuses,
  EUserPermissions, IActivity,
  IBatch,
  IFacility
} from '@zunta/configurations'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Confirm from '@/components/Confirm.vue'
import { ETableColumnType, ISelectItem, ITableConfig } from '@/interfaces'
import { StatementModule } from '@/store/modules/statement.module'
import { FacilityModule } from '@/store/modules/facility.module'
import Api from '@/api'
import { User } from '@/classes/User'
import Switcher from '@/components/Switcher.vue'
import DownloadModal from '@/views/app/management/mailings/components/DownloadModal.vue'
import Card from '@/components/Card.vue'
import moment from 'moment'
import FacilityLabel from '@/components/labels/FacilityLabel.vue'
import Table from '@/components/tables/Table.vue'
import { BatchModule } from '@/store/modules/batch.module'
import StatusBatch from '@/components/statuses/StatusBatch.vue'
import StatementsMailSuccessModal from '@/views/app/management/mailings/components/StatementsMailSuccessModal.vue'
import StatementsMailCompleteModal from '@/views/app/management/mailings/components/StatementsMailCompleteModal.vue'
import ModalV2 from '@/components/modals/ModalV2.vue'
import { makeErrorNotification } from '@/utils/notification'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { isFacilityFeatureBlocked } from '@/utils/facility/facilityFeatures'

@Component({
  components: {
    ModalV2,
    StatementsMailSuccessModal,
    StatementsMailCompleteModal,
    StatusBatch,
    Table,
    FacilityLabel,
    Card,
    DownloadModal,
    Icon,
    Confirm,
    DateTimeLabel,
    Switcher,
    LoaderWrapper
  }
})
export default class ManagementMailing extends Vue {
  statementModuleInstance: StatementModule = getModule(StatementModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  batchModuleInstance: BatchModule = getModule(BatchModule, this.$store)
  EBatchStatus = EBatchStatus
  EBatchType = EBatchType
  EStatementStatuses = EStatementStatuses
  EUserPermissions: any = EUserPermissions
  user: User = Api.getUser() as User
  moment: any = moment
  isLoading: boolean = false
  batchForMail: IBatch | null = null
  shouldShowStatementsMailSuccessMessage: boolean = false
  shouldShowStatementsMailCompleteMessage: boolean = false

  statusFilters: Array<ISelectItem> = [
    {
      key: 'complete',
      content: 'Complete',
      value: 'COMPLETE'
    },
    {
      key: 'incompelte',
      content: 'Incomplete',
      value: 'INCOMPLETE'
    },
    {
      key: 'returned',
      content: 'Returned Mail',
      value: 'RETURNED_MAIL'
    }
  ]
  typeFilters: Array<ISelectItem> = [
    {
      key: EBatchType.LETTERS,
      content: 'Letters',
      value: EBatchType.LETTERS
    },
    {
      key: EBatchType.STATEMENTS,
      content: 'Statements',
      value: EBatchType.STATEMENTS
    },
    {
      key: EBatchType.COLLECTION_MAIL,
      content: 'Collection Mail',
      value: EBatchType.COLLECTION_MAIL
    }
  ]
  removableBatchId: number | null = null

  shouldConfirmRemoveBatch: boolean = false
  deletingBatch: boolean = false
  isMailing: boolean = false
  shouldConfirmMail: boolean = false
  showDownloadModal: boolean = false
  batchToDownload: IBatch | undefined

  batchDeleteMessage: String = ''
  activities: IActivity[] = []

  filters: any = {
    test: this.$route.query.showCompleteBatches,
    limit: 20,
    skip: 0,
    showCompleteBatches: this.$route.query.showCompleteBatches && this.$route.query.showCompleteBatches === 'true' ? this.$route.query.showCompleteBatches : 'false'
  }

  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
      class: 'rounded-bottom'
    },
    usePagination: true,
    useQuery: true,
    fetchFunction: this.batchModuleInstance.getBatchListByFilters,
    rowClick: this.goBatch,
    maxHeight: 'calc(100vh - 559px)',
    minHeight: '100px',
    columns: [
      {
        minWidth: '100px',
        width: 10,
        key: 'date',
        searchKey: 'date',
        hasSearch: true,
        hasSort: true,
        label: 'Date',
        type: ETableColumnType.dateRange
      },
      {
        minWidth: '100px',
        width: 10,
        key: 'createdBy',
        searchKey: 'createdBy',
        hasSearch: true,
        hasSort: true,
        label: 'Created By',
        type: ETableColumnType.default
      },
      {
        minWidth: '100px',
        width: 10,
        key: 'facility',
        searchKey: 'facilityName',
        hasSearch: true,
        hasSort: true,
        label: 'Facility',
        type: ETableColumnType.default
      },
      {
        minWidth: '100px',
        width: 10,
        key: 'type',
        searchKey: 'type',
        hasSearch: true,
        hasSort: true,
        label: 'Type',
        type: ETableColumnType.multiselect,
        options: this.typeFilters
      },
      {
        minWidth: '130px',
        width: 13,
        key: 'status',
        searchKey: 'status',
        hasSearch: true,
        hasSort: true,
        label: 'Status',
        type: ETableColumnType.multiselect,
        options: this.statusFilters
      },
      {
        minWidth: '70px',
        width: 5,
        // class: 'text-center',
        key: 'totalCount',
        searchKey: 'totalCount',
        hasSearch: true,
        hasSort: true,
        label: 'Total',
        type: ETableColumnType.number
      },
      {
        minWidth: '70px',
        width: 5,
        // class: 'text-center',
        key: 'readyToMailCount',
        searchKey: 'readyToMailCount',
        hasSearch: true,
        hasSort: true,
        label: 'Ready to Mail',
        type: ETableColumnType.number
      },
      {
        minWidth: '70px',
        width: 5,
        // class: 'text-center',
        key: 'notReadyCount',
        searchKey: 'notReadyCount',
        hasSearch: true,
        hasSort: true,
        label: 'Not Ready',
        type: ETableColumnType.number
      },
      {
        minWidth: '70px',
        width: 5,
        // class: 'text-center',
        key: 'doNotMailCount',
        searchKey: 'doNotMailCount',
        hasSearch: true,
        hasSort: true,
        label: 'Do Not Mail',
        type: ETableColumnType.number
      },
      {
        minWidth: '70px',
        width: 5,
        // class: 'text-center',
        key: 'mailedCount',
        searchKey: 'mailedCount',
        hasSearch: true,
        hasSort: true,
        label: 'Mailed',
        type: ETableColumnType.number
      },
      {
        minWidth: '70px',
        width: 5,
        // class: 'text-center',
        key: 'returnedCount',
        searchKey: 'returnedCount',
        hasSearch: true,
        hasSort: true,
        label: 'Returned',
        type: ETableColumnType.number
      },
      {
        minWidth: '100px',
        width: 9,
        key: 'lastUpdate',
        searchKey: 'lastUpdate',
        hasSearch: true,
        hasSort: true,
        label: 'Last Updated',
        type: ETableColumnType.dateRange
      },
      {
        minWidth: '180px',
        class: 'text-right',
        headClass: 'bt-justify-content-end',
        width: 8,
        key: 'actions'
      }
    ]
  }

  get confirmMessage () {
    if (!this.mailStatementsSum) {
      return 'There are no statements to mail out.'
    }
    if (this.batchForMail && Number(this.batchForMail.notReadyCount) === 0) {
      return `Your batch is ready to go! Are you ready to send ${this.mailStatementsSum} statement(s)?`
    }
    return `Are you sure you would like to send ${this.mailStatementsSum} statement(s)?`
  }

  get confirmContent () {
    if (!this.mailStatementsSum) {
      return ''
    }
    return `
      <p><b>${this.mailStatements.mailed}</b> statements will be mailed.</p>
      <p><b>${this.mailStatements.paperless}</b> statements will be emailed.</p>
      <p><b>${this.mailStatements.deliverToRoom}</b> statements will be delivered to resident’s room by ${this.mailStatementsUser}</p>
     `
  }

  get mailStatementsUser () {
    if (!this.mailStatements.printedStatementUser) {
      return ''
    }
    const user = this.mailStatements.printedStatementUser
    return `${user && user.firstName ? user.firstName : ''} ${user && user.lastName ? user.lastName : ''}`
  }

  get showReviewBtn () {
    return this.batchForMail && this.batchForMail.notReadyCount > 0
  }

  get confirmSubMessage () {
    if (!this.mailStatementsSum) {
      return ''
    }
    return 'You will not be able to cancel this action.'
  }

  get batchListTotal () {
    return this.$store.state.batch.total
  }

  get batchList () {
    return this.$store.state.batch.batchList
  }

  get statistics () {
    return this.$store.state.statement.statistics
  }

  get mailStatements () {
    return this.$store.state.statement.mailStatements
  }

  get mailStatementsSum () {
    return this.mailStatements ? this.mailStatements.deliverToRoom + this.mailStatements.paperless + this.mailStatements.mailed : 0
  }

  get dashboardStatistics () {
    return this.$store.state.batch.statementsBatchDashboardStatistics
  }

  mounted () {
    this.$eventBus.$on('downloading', this.downloadingStatus)
    this.$eventBus.$on('hasCorruptFiles', this.doMakeErrorNotification)
    this.statementModuleInstance.getStatistics()
    this.$eventBus.$on('reload-batch-list', async () => {
          // @ts-ignore
          if (this.$refs.table) {
            // @ts-ignore
            this.$refs.table.initSearch()
          }
          await this.statementModuleInstance.getStatistics()
        }
    )
  }

  destroyed () {
    this.$eventBus.$off('reload-batch-list')
  }

  closeConfirmMail () {
    this.batchForMail = null
    this.shouldConfirmMail = false
    this.statementModuleInstance.clearMailStatements()
  }

  openConfirmMail (batch: IBatch) {
    this.batchForMail = batch
    this.statementModuleInstance.fetchMailStatements(batch.id)
    this.shouldConfirmMail = true
  }

  async mail () {
    if (!this.batchForMail || !this.user.hasPermissionFor(EUserPermissions.MAIL_STATEMENTS)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: `Mail Statements`,
        icon: 'warning'
      })
      return
    }
    this.isMailing = true
    const response: any = await this.statementModuleInstance.sendStatementsBatchMails(this.batchForMail.id)
    this.isMailing = false
    this.shouldConfirmMail = false

    if (response !== 'Fail') {
      // this.$eventBus.$emit('notify', {
      //   color: 'var(--status-success-color)',
      //   message: 'Process Started',
      //   header: `Statements sending Via Mail`,
      //   icon: 'check'
      // })
      await this.batchModuleInstance.getStatementsBatchDashboardStatistics(this.batchForMail.id)
      if (this.dashboardStatistics[EStatementStatuses.NEEDS_FIX] === 0 &&
        this.dashboardStatistics[EStatementStatuses.NEEDS_REVIEW] === 0) {
        // this.shouldShowStatementsMailCompleteMessage = true
        this.shouldShowStatementsMailSuccessMessage = true
      } else {
        this.shouldShowStatementsMailSuccessMessage = true
      }
      return
    }
    this.$eventBus.$emit('notify', {
      color: 'var(--status-error-color)',
      message: 'Process Failed',
      header: `Statements sending Via Mail`,
      icon: 'warning'
    })
  }

  getBatchStatusLabel (status: string) {
    const STATUSES_MAP: { [k: string]: string } = {
      [EBatchStatus.COMPLETE]: 'Complete',
      [EBatchStatus.INCOMPLETE]: 'Incomplete',
      [EBatchStatus.RETURNED_MAIL]: 'Returned Mail'
    }
    return STATUSES_MAP[status]
  }

  getTypeLabel (type: EBatchType) {
    const TYPES_MAP: any = {
      [EBatchType.LETTERS]: 'Letters',
      [EBatchType.STATEMENTS]: 'Statements',
      [EBatchType.RETURNED_MAILS]: 'Returned Mail',
      [EBatchType.COLLECTION_MAIL]: 'Collection Mail'
    }
    return TYPES_MAP[type]
  }

  async updateStatements (batch: IBatch) {
    let response
    if ((batch.facility as IFacility).origin === EOrigin.PCC) {
      response = await this.statementModuleInstance.fetchBatchStatements({ batchId: batch.id, isUpdating: true })
    }
    if ((batch.facility as IFacility).origin === EOrigin.NCS) {
      response = await this.statementModuleInstance.fetchBatchNCSStatements({ batchId: batch.id, isUpdating: true })
    }
    if (response === 'OK') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        message: 'Process Started',
        header: `Statements Updating...`,
        icon: 'check'
      })
      return
    }
    this.$eventBus.$emit('notify', {
      color: 'var(--status-error-color)',
      message: 'Process Failed',
      header: `Statements Updating...`,
      icon: 'warning'
    })
  }

  async openConfirmRemoveBatch (batch: IBatch) {
    if (batch.mailedCount) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Action not allowed. This batch has already mailed statements',
        header: `Deleting batch`,
        icon: 'warning'
      })
      return
    }
    const hasPendingActivities = await Api.statement.batchHasPendingActivities(batch.id)
    if (hasPendingActivities) {
      this.batchDeleteMessage = `Are you sure that you want to delete batch for ${(batch.facility as IFacility).name}? <br/> This will remove all statements for this batch and stop any updates that are in process.`
    } else {
      this.batchDeleteMessage = `Are you sure that you want to delete batch for ${(batch.facility as IFacility).name}? <br/> This will remove all statements for this batch.`
    }
    this.removableBatchId = batch.id
    // const batchActivities = this.
    this.shouldConfirmRemoveBatch = true
  }

  closeRemoveBatchConfirm () {
    this.shouldConfirmRemoveBatch = false
  }

  doMakeErrorNotification (message: string) {
    makeErrorNotification(this, message)
  }

  downloadingStatus (status: boolean) {
    this.isLoading = status
  }

  async removeBatch () {
    if (!this.removableBatchId) {
      this.shouldConfirmRemoveBatch = false
      return
    }

    this.deletingBatch = true
    const res = await this.batchModuleInstance.deleteBatch(this.removableBatchId)
    this.deletingBatch = false
    this.shouldConfirmRemoveBatch = false

    // @ts-ignore
    this.$refs.table.initSearch()
    await this.statementModuleInstance.getStatistics()

    if (res !== 'OK') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        // @ts-ignore
        message: res.message,
        header: `Delete Batch`,
        icon: 'warning'
      })
    }
  }

  goBatch (batch: IBatch) {
    this.batchModuleInstance.toggleBatchAlert(true)
    this.$locationManager.rememberAndGoTo({
      name: 'management-mailings-batch', params: { id: batch.id.toString() }
    })
  }

  batchHavePayers (batch: any): boolean {
    return batch.payers && batch.payers.length && batch.payers[0] !== '[]'
  }

  getBatchTooltipLabel (batch: any): string {
    if (!this.batchHavePayers(batch)) {
      return ''
    }

    let text = '<ul class="tooltip-list">'
    batch.payers.forEach((payer: any) => {
      text += `<li class="tooltip-item">• ${payer.payer_name}</li>`
    })
    text += '</ul>'
    return text
  }

  getBatchLabel (batch: any): string {
    if (!this.batchHavePayers(batch)) {
      return 'All payers'
    }

    if (batch.includeAllPayers) {
      return 'All payers'
    }

    if (batch.payers.length === 1) {
      return batch.payers[0].payer_name
    }

    let text = ''
    batch.payers.forEach((payer: any) => {
      text += `${payer.payer_name}, `
    })
    return text
  }

  get deleteBatchMessage () {
    // @ts-ignore
    const batch: IBatch = this.batchList.find((batch: IBatch) => batch.id === this.removableBatchId)
    // @ts-ignore
    const name = batch && batch.facility ? batch.facility.name : 'this facility'
    return `Are you sure that you want to delete batch for ${name}? This will remove all statements in the batch.`
  }

  toggleDownload (show: boolean, batch?: IBatch) {
    this.showDownloadModal = show
    this.batchToDownload = show ? batch : undefined
  }

  isStatementGenAndMailBlocked (facility: IFacility) {
    return isFacilityFeatureBlocked(facility, EFacilityBlockableFeatures.MailAndGenStatements)
  }
}
